<mat-dialog-content>
  <div *ngIf="!!constructionUnit"
    id="construction-unit-dialog-content">
    <div style="margin-bottom: 2em;">
      <div style="font-size: large">
        <strong>{{ constructionUnit?.Identifier }}</strong><br />
        <strong>{{ constructionUnit?.Name }} ({{ constructionUnit?.UnitOfMeasure }})</strong>
      </div>

      <div>
        <p>{{ constructionUnit?.Version.Name }}, {{ constructionUnit?.Group.Name }}</p>
      </div>
    </div>

    <div>
      <div *ngIf="!isComponent">
        <mat-hint>{{ 'task.unit.includes' | blah }}</mat-hint>
        <p id="construction-unit-dialog-includes">{{ constructionUnit?.Includes || '-' }}</p>
      </div>

      <div *ngIf="!isComponent">
        <mat-hint>{{ 'task.unit.doesNotInclude' | blah }}</mat-hint>
        <p id="construction-unit-dialog-doesnotinclude">{{ constructionUnit?.DoesNotInclude || '-'}}</p>
      </div>

      <div>
        <mat-hint>{{ 'task.unit.notes' | blah }}</mat-hint>
        <p id="construction-unit-dialog-notes">{{ constructionUnit?.Notes || '-' }}</p>
      </div>
    </div>
  </div>
  <div *ngIf="!constructionUnit">
    {{ 'task.unit.fetchingConstructionUnitFailed' | blah }}
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end"
  *ngIf="!mobile">
  <hpo-button id="close-construction-unit-dialog-btn"
    (click)="close()">{{ 'default.close' | blah }}</hpo-button>
</mat-dialog-actions>